import {
  GET_EDIT_ROLE_DATA_RESPONSE,
  GET_MODULES_PERMISSIONS_RESPONSE,
  ROLE_DETAILS_RESPONSE,
  ROLES_LIST_RESPONSE
} from "./types";

const INITIAL_STATE = {
  rolesList: {
    list: [],
    meta: {}
  },
  modulesPermissions: [],
  editRoleData: {},
  roleDetails: {}
};

const roles = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ROLES_LIST_RESPONSE:
      return {
        ...state,
        rolesList: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case ROLE_DETAILS_RESPONSE:
      return {
        ...state,
        roleDetails: action.payload
      };
    case GET_MODULES_PERMISSIONS_RESPONSE:
      return {
        ...state,
        modulesPermissions: action.payload
      };
    case GET_EDIT_ROLE_DATA_RESPONSE:
      return {
        ...state,
        editRoleData: action.payload
      };
    default:
      return state;
  }
};

export default roles;
